import React, { useState, useEffect, useRef } from 'react';
import '../../css/spendMarketPlace.css';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../CustomButton';
import { GoDotFill } from "react-icons/go";
import { FaArrowRightLong } from "react-icons/fa6";
import MainImgMarketplace from '../../assets/img/sliderMarketplace/imgSliderMarketplace.jpg'
import ImgBgAdsOne from '../../assets/img/marketplaceAds/one.jpg'
import ImgBgAdsTwo from '../../assets/img/marketplaceAds/two.jpg'
import ImgBgAdsThree from '../../assets/img/marketplaceAds/three.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
import { Autoplay, Pagination, FreeMode, Scrollbar, Mousewheel, Navigation } from 'swiper/modules';
import adsSliderSpendMarketPlaceData from '../../mock/adsSliderSpendMarketPlace.json'
import adsMpOfferData from '../../mock/adsMpOffer.json'

function SpendMarketPlace() {

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const navigate = useNavigate();
    const [scrollIndex, setScrollIndex] = useState(0);
    const [progressPercent, setProgressPercent] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleScroll = () => {
            const children = Array.from(container.children);
            const containerScrollTop = container.scrollTop;
            const containerHeight = container.clientHeight;
            const containerScrollHeight = container.scrollHeight;

            // --- Progress calculation ---
            const scrollableHeight = containerScrollHeight - containerHeight;
            const percent = (containerScrollTop / scrollableHeight) * 100;
            setProgressPercent(percent);

            // --- Active item index ---
            let maxVisibleRatio = 0;
            let mostVisibleIndex = 0;

            children.forEach((child, index) => {
                const rect = child.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();

                const visibleTop = Math.max(rect.top, containerRect.top);
                const visibleBottom = Math.min(rect.bottom, containerRect.bottom);
                const visibleHeight = Math.max(0, visibleBottom - visibleTop);
                const ratio = visibleHeight / rect.height;

                if (ratio > maxVisibleRatio) {
                    maxVisibleRatio = ratio;
                    mostVisibleIndex = index;
                }
            });

            // Special case: scrolled to bottom
            if (Math.ceil(containerScrollTop + containerHeight) >= containerScrollHeight) {
                setScrollIndex(children.length - 1);
            } else {
                setScrollIndex(mostVisibleIndex);
            }
        };

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
    }, []);

    const [swiperIndexOne, setSwiperIndexOne] = useState(0);
    const [swiperInstanceOne, setSwiperInstanceOne] = useState(null);

    const handleSwiperSlideChangeOne = (swiperOne) => {
        setSwiperIndexOne(swiperOne.activeIndex);
    };

    const showSwiperIndex = swiperIndexOne === 10 ? `${swiperIndexOne + 1}` : swiperIndexOne === 0 ? `${swiperIndexOne}1` : `0${swiperIndexOne + 1}`;
    const showLastSwiperIndex = adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length >= 10 ? `${adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length}` : adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length >= 1 && `0${adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length}`

    const hadleBtnBoxGoPartnersList = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleBtnBoxGoAddCard = () => {
        navigate('/configuracoes/associar-cartao/tipo-de-associacao');
    };

    const hadleBtnBoxGoMarketplace = () => {
        window.open('https://marketplace.medis.pt/', '_blank');
    };

    const hadleBtnBoxGoSupport = () => {
        window.open('https://saude360.medis.pt/apoio-ao-cliente/', '_blank');
    };

    const hadleBtnBoxGoTerms = () => {
        window.open('https://saude360.medis.pt/informacao-legal/', '_blank');
    };

    const ImgBgAds = {
        "1": ImgBgAdsOne,
        "2": ImgBgAdsTwo,
        "3": ImgBgAdsThree
    };

    const handleBtnBoxGoAds = (url) => {
        if (url) {
            window.open(url, '_blank')
        }
    }

    return (
        <>
        <div className={ isTablet ? 'secondMainContainerSpendMarketPlace' : ( isMobile ? 'secondMainContainerSpendMarketPlaceTablet' : 'secondMainContainerSpendMarketPlaceMobile') }>
            <div className={ isTablet ? 'firstSubMainContainerSpendMarketPlace'  : ( isMobile ? 'firstSubMainContainerSpendMarketPlaceTablet' : 'firstSubMainContainerSpendMarketPlaceMobile') }>
                <div className='secondTitleViewSpendMarketPlace'>
                    <div className='textTitleRegular400SpendMarketPlace'>Use o seu saldo e pague menos no Marketplace</div>
                    <div className='textSecondTitleViewSpendMarketPlace'>Acumule saldo fazendo compras nas centenas de parceiros Carteira Médis e desconte esse valor nas compras no Marketplace Médis. </div>
                </div>
            </div>
            <div className={ isTablet ? 'secondSubMainContainerSpendMarketPlace' : ( isMobile ? 'secondSubMainContainerSpendMarketPlaceTablet' : 'secondSubMainContainerSpendMarketPlaceMobile' )}>
                <div className={ isTablet ? 'secondSubMainFirsViewContainerSpendMarketPlace' : ( isMobile ? 'secondSubMainFirsViewContainerSpendMarketPlaceTablet' : 'secondSubMainFirsViewContainerSpendMarketPlaceMobile' )}>
                    <div className='txtFirsinfoViewContainerSpendMarketPlace'>
                        <div className='titleFirsinfoViewContainerSpendMarketPlace'>
                            <div className='titleFirsinfoContainerSpendMarketPlace'>Pague menos no Marketplace</div>
                        </div>
                        <div className='txtRegularFirsinfoViewContainerSpendMarketPlace'>
                            <div className='txtRegularFirsSubinfoViewContainerSpendMarketPlace'>
                                <div className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>
                                    <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>1. Ative a sua Carteira Virtual Médis e </span>
                                    <span className='txtBntTitleRegularFirsinfoContainerSpendMarketPlace' onClick={hadleBtnBoxGoAddCard}>associe um cartão bancário</span>
                                </div>
                                <div className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>
                                    <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>2. Faça compras na </span>
                                    <span className='txtBntTitleRegularFirsinfoContainerSpendMarketPlace' onClick={hadleBtnBoxGoPartnersList}>rede de parceiros</span>
                                    <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'> e acumule saldo na Carteira</span>
                                </div>
                                <div className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>
                                    <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>3. Desconte o saldo da Carteira Médis nas compras que fizer no </span>
                                    <span className='txtBntTitleRegularFirsinfoContainerSpendMarketPlace' onClick={hadleBtnBoxGoMarketplace}>Marketplace Médis</span>
                                    <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>.</span>
                                </div>
                            </div>
                            <div className='txtTitleBoldFirsinfoContainerSpendMarketPlace'>
                                <span className='txtTitleBoldFirsinfoContainerSpendMarketPlace'>Não precisa de ter seguro Médis </span>
                                <span className='txtTitleRegularFirsinfoContainerSpendMarketPlace'>para usar a Carteira ou o Marketplace Médis.</span>
                            </div>
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnFirsinfoViewContainerSpendMarketPlace' : ( isMobile ? 'btnFirsinfoViewContainerSpendMarketPlaceTablet' : 'btnFirsinfoViewContainerSpendMarketPlaceMobile' )}>
                        <CustomButton 
                            text={'Ver Marketplace Médis'} 
                            onPress={hadleBtnBoxGoMarketplace}
                            textColor={'#00214D'}
                            color={'#15D4B6'}
                            hasArrow
                            iconColor={'#00214D'}
                            fontSize={'14px'}
                        />
                    </div>
                </div>
                <div className={ isTablet ? 'secondSubMainSecondViewContainerSpendMarketPlace' : ( isMobile ? 'secondSubMainSecondViewContainerSpendMarketPlaceTablet' : 'secondSubMainSecondViewContainerSpendMarketPlaceMobile' )}>
                    { isTablet ?
                        null
                        : 
                        <div className={ isTablet ? 'mainInfoSliderIndexViewContainerSpendMarketPlace' : ( isMobile ? 'mainInfoSliderIndexViewContainerSpendMarketPlaceTablet' : 'mainInfoSliderIndexViewContainerSpendMarketPlaceMobile')}>
                            <div className='txtInfoSliderIndexViewSpendMarketPlace'>{scrollIndex + 1}</div>

                            <div className="customSliderProgressBarContainerHorizontal">
                                <div
                                    className="customSliderProgressBarFillHorizontal"
                                    style={{
                                        width: `${progressPercent}%`,
                                    }}
                                    />
                            </div>
                            
                            <div className='txtInfoSliderIndexViewSpendMarketPlace'>{adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length}</div>
                        </div> 
                    }
                    <div className={ isTablet ? 'secondSubMainSecondViewContentContainerSpendMarketPlace' : ( isMobile ? 'secondSubMainSecondViewContentContainerSpendMarketPlaceTablet' : 'secondSubMainSecondViewContentContainerSpendMarketPlaceMobile' )}>

                        <div className={ isTablet ? 'mainSliderViewContentcontainerSpendMarketPlace' : 'mainSliderViewContentcontainerSpendMarketPlaceMobile'} ref={containerRef}>
                            {adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.map((item, index) => (
                            
                                <div key={index} className='mainSubSliderViewContentcontainerSpendMarketPlace'>
                                    <div className={ isTablet ? 'txtTitleViewSliderIndexSpendMarketPlace' : (isMobile ? 'txtTitleViewSliderCentredIndexSpendMarketPlaceTablet' : 'txtTitleViewSliderCentredIndexSpendMarketPlaceMobile')}>
                                        {/* <div className='txtSliderIndexViewSpendMarketPlace'>{index + 1}</div> */}
                                        <div className='txtTitleSliderIndexViewSpendMarketPlace'>{item.title}</div>
                                    </div>
                                    <div className={ isTablet ? 'txtTitleViewSliderIndexSpendMarketPlace' : (isMobile ? 'txtTitleViewSliderCentredIndexSpendMarketPlaceTablet' : 'txtTitleViewSliderCentredIndexSpendMarketPlaceMobile')}>
                                        <div className='txtDescriptionSliderIndexViewSpendMarketPlace'>{item.description}</div>
                                        {item.subDescriptions && Object.values(item.subDescriptions).some(val => val) && (
                                            <div className='mainColumnRespSliderViewContentcontainerSpendMarketPlace'>
                                                {item.subDescriptions.titleBold && (
                                                    <div className='mainRowRespSliderViewContentcontainerSpendMarketPlace'>
                                                        <div className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'> &#x2022; </div>
                                                        <div className='txtDescriptionSliderIndexViewSpendMarketPlace'>
                                                            <span className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'>{item.subDescriptions.titleBold}</span>
                                                            <span className='txtDescriptionSliderIndexViewSpendMarketPlace'>{item.subDescriptions.description}</span>
                                                        </div>
                                                    </div>
                                                )}
                                                {item.subDescriptions.titleBoldTwo && (
                                                    <div className='mainRowRespSliderViewContentcontainerSpendMarketPlace'>
                                                        <div className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'> &#x2022; </div>
                                                        <div className='txtDescriptionSliderIndexViewSpendMarketPlace'>
                                                            <span className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'>{item.subDescriptions.titleBoldTwo}</span>
                                                            <span className='txtDescriptionSliderIndexViewSpendMarketPlace'>{item.subDescriptions.descriptionTwo}</span>
                                                        </div>
                                                    </div>
                                                )}
                                                {item.subDescriptions.titleBoldThree && (
                                                    <div className='mainRowRespSliderViewContentcontainerSpendMarketPlace'>
                                                        <div className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'> &#x2022; </div>
                                                        <div className='txtDescriptionSliderIndexViewSpendMarketPlace'>
                                                            <span className='txtDescriptionBoldSliderIndexViewSpendMarketPlace'>{item.subDescriptions.titleBoldThree}</span>
                                                            <span className='txtDescriptionSliderIndexViewSpendMarketPlace'>{item.subDescriptions.descriptionThree}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                            
                                        
                                    </div>
                                    { item?.imageUrl === true && 
                                        <div className='imgViewSliderIndexSpendMarketPlace'>
                                            <img src={MainImgMarketplace} alt='imagem' className='imgSliderIndexSpendMarketPlace' />
                                        </div>
                                    }
                                    { item?.hasInfoBtns === true && 
                                        <div className={ isTablet ? 'btnViewSliderIndexSpendMarketPlace' : ( isMobile ? 'btnViewSliderIndexSpendMarketPlaceTablet' : 'btnViewSliderIndexSpendMarketPlaceMobile' )}>
                                            <CustomButton 
                                                text={'Ver Perguntas Frequentes'} 
                                                textColor={'#515151'}
                                                hasShadow={false}
                                                justText
                                                hasArrow
                                                iconType={'arrowOutward'}
                                                iconColor={'#515151'}
                                                isSmall={isTablet ? false : (isMobile ? false : true)}
                                                onPress={hadleBtnBoxGoSupport}
                                            />
                                            <CustomButton 
                                                text={'Ver Termos e Condições da Carteira'} 
                                                textColor={'#515151'}
                                                hasShadow={false}
                                                justText
                                                hasArrow
                                                iconType={'arrowOutward'}
                                                iconColor={'#515151'}
                                                isSmall={isTablet ? false : (isMobile ? false : true)}
                                                onPress={hadleBtnBoxGoTerms}
                                            />
                                        </div>
                                    }
                                    { item?.hasInfoBtn === true && 
                                        <div className={ isTablet ? 'btnViewSliderIndexSpendMarketPlace' : ( isMobile ? 'btnViewSliderIndexSpendMarketPlaceTablet' : 'btnViewSliderIndexSpendMarketPlaceMobile' )}>
                                            <CustomButton 
                                                text={'Ver Termos e Condições campanhas Marketplace'} 
                                                textColor={'#515151'}
                                                hasShadow={false}
                                                justText
                                                hasArrow
                                                iconType={'arrowOutward'}
                                                iconColor={'#515151'}
                                                isSmall={isTablet ? false : (isMobile ? false : true)}
                                                onPress={hadleBtnBoxGoTerms}
                                            />
                                        </div>
                                    }
                                </div>
                            
                        ))}
                    </div>
                        { isTablet ?
                            <div className={ isTablet ? 'mainInfoSliderIndexViewContainerSpendMarketPlace' : ( isMobile ? 'mainInfoSliderIndexViewContainerSpendMarketPlaceTablet' : 'mainInfoSliderIndexViewContainerSpendMarketPlaceMobile')}>
                                <div className='txtInfoSliderIndexViewSpendMarketPlace'>{scrollIndex + 1}</div>

                                <div className="customSliderProgressBarContainerVertical">
                                    <div
                                        className="customSliderProgressBarFillVertical"
                                        style={{
                                            height: `${progressPercent}%`
                                        }}
                                        />
                                </div>
                                
                                <div className='txtInfoSliderIndexViewSpendMarketPlace'>{adsSliderSpendMarketPlaceData.sliderSpendMarketPlaceAds.length}</div>
                            </div>
                            : ( isMobile ? null : null )
                        }
                    </div>
                </div>
            </div>
            <div className={ isTablet ? 'thirdSubMainContainerSpendMarketPlace' : ( isMobile ? 'thirdSubMainContainerSpendMarketPlaceTablet' : 'thirdSubMainContainerSpendMarketPlaceMobile')}>
                <div className='secondTitleViewSpendMarketPlace'>
                    <div className='textTitleRegular400SpendMarketPlace'>Marketplace Médis</div>
                    <div className='textBottomSecondTitleViewSpendMarketPlace'>Conheça os milhares de produtos de saúde, bem-estar, gravidez, bebé, desporto, beleza e cuidado pessoal.</div>
                </div>
                <div className='thirdSubSubMainContainerSpendMarketPlace'>
                    <div className={ isTablet ? 'mainViewContainerAdsMpSpendMarketPlace' :( isMobile ? 'mainViewContainerAdsMpSpendMarketPlaceTablet' : 'mainViewContainerAdsMpSpendMarketPlaceMobile' )}>
                        { adsMpOfferData.mpOfferAds.map((item, index) => (
                            <div 
                                key={index} 
                                className='mainBoxViewContainerAdsMpSpendMarketPlace' 
                                style={{ 
                                    backgroundImage: `url(${ImgBgAds[item.imageUrl]})`, 
                                    backgroundSize: 'cover', 
                                    lightingColor: '50%',
                                    backgroundPosition: 'center' 
                                }}
                                onClick={() => handleBtnBoxGoAds(item.navUrl)}>
                                <div className='infoStatusAdsBoxViewSpendMarketPlace'>
                                    <div className='iconInfoStatusAdsBoxViewSpendMarketPlace'><GoDotFill /></div>
                                    <div className='txtInfoStatusAdsBoxViewSpendMarketPlace'>{item.status}</div>
                                </div>
                                <div className='contentMasckContainerAdsBoxViewSpendMarketPlace'>
                                    <div className='contentContainerAdsBoxViewSpendMarketPlace'>
                                        <div className='titleFirsinfoViewContainerSpendMarketPlace'>
                                            <div className='txtTitleAdsBoxViewSpendMarketPlace'>{item.title}</div>
                                        </div>
                                        <div className='descBtnViewContainerAdsBoxViewSpendMarketPlace'>
                                            <div className='textSecondTitleViewSpendMarketPlace'>{item.description}</div>
                                            <div className='btnViewContainerAdsBoxViewSpendMarketPlace'>
                                                <div className='arrowIconBtnAdsBoxViewSpendMarketPlace'><FaArrowRightLong /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        }
                        
                    </div>
                    <div className={'btnBottomViewContainerSpendMarketPlaceMobile'}>
                        <CustomButton 
                            text={'Ver Marketplace Médis'} 
                            onPress={hadleBtnBoxGoMarketplace}
                            textColor={'#00214D'}
                            borderColor={'#00214D'}
                            hasArrow
                            iconColor={'#00214D'}
                            fontSize={'14px'}
                            hasShadow={false}
                        />
                    </div> 
                </div>
            </div> 
        </div>   
        </>       
    )
}

export default SpendMarketPlace